<template>
  <div class="food-result edit-dialog">
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item>
          <md-icon
            slot="default"
            style="float:right;cursor:pointer"
            @click.native="closeDialog()"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <mu-paper style="position: relative; z-index: 99">
      <mu-list>
        <mu-list-item disableRipple :describeText="food.brand_name">
          <div slot="title">
            <span v-text="isLoading ? $t('message.loadingText') : food.food_name"></span>
          </div>
        </mu-list-item>
      </mu-list>
      <div v-if="food.food_name">
        <mu-row gutter v-if="!isLoading">
          <mu-col width="100" :desktop="leftPaneWidth.desktop" :tablet="leftPaneWidth.tablet" class="bottom">
            <mu-content-block style="padding: 16px 24px;">
              <mu-row gutter style="margin-bottom: 8px">
                <mu-col width="50" :desktop="servingPickerWidth.servingInput.desktop"
                        :tablet="servingPickerWidth.servingInput.tablet"
                >
                  <mu-text-field
                    v-validate="'required|min_value:0|max_value:99'"
                    data-vv-name="serving_size"
                    data-vv-as="serving size"
                    :errorText="errors.first('serving_size')"
                    v-model.number="model.servings"
                    :min="0"
                    type="number"
                    hintText="Multiplier"
                    :label="$t('message.labelServingSize')"
                    fullWidth
                  ></mu-text-field>
                  <span>
                  <mu-flexbox align="center" style="height: 34px;">
                    <mu-flexbox-item style="font-weight: 500"
                                     v-text="$t('message.foodDiaryQuickPortionLabel')"></mu-flexbox-item>
                  </mu-flexbox>
                </span>
                </mu-col>
                <mu-col
                  width="50"
                  :desktop="servingPickerWidth.servingSelector.desktop"
                  :tablet="servingPickerWidth.servingSelector.tablet"
                >
                  <mu-select-field
                    :scroller="scroller"
                    :maxHeight="248"
                    label=" "
                    v-model.number="model.serving_id"
                    fullWidth
                    autoWidth>
                    <mu-menu-item
                      v-for="serving, index in food.servings"
                      :key="'serving-' + index"
                      :value="serving.serving_id"
                      :title="serving.serving_description"
                    ></mu-menu-item>
                  </mu-select-field>
                  <span>
                  <mu-chip @click.native="setServingSize('0.25')">1/4</mu-chip>
                  <mu-chip @click.native="setServingSize('0.5')">1/2</mu-chip>
                  <mu-chip @click.native="setServingSize('0.75')">3/4</mu-chip>
                  <mu-chip @click.native="setServingSize('1')">1</mu-chip>
                </span>
                </mu-col>
              </mu-row>
              <mu-row gutter>
                <mu-col :desktop="servingPickerWidth.servingInput.desktop"
                        :tablet="servingPickerWidth.servingInput.tablet">
                  <mu-time-picker
                    :label="$t('message.labelTime')"
                    mode="landscape"
                    fullWidth
                    v-model="timeModel.time"
                    :okLabel="$t('message.okText')"
                    :cancelLabel="$t('message.cancelText')"></mu-time-picker>
                </mu-col>
                <mu-col :desktop="servingPickerWidth.servingSelector.desktop"
                        :tablet="servingPickerWidth.servingSelector.tablet">
                  <mu-date-picker
                    :label="$t('message.labelDate')"
                    :okLabel="$t('message.okText')"
                    :cancelLabel="$t('message.cancelText')"
                    :dateTimeFormat="dateFormat"
                    format="DD-MM-YYYY"
                    v-model="timeModel.date"
                    fullWidth></mu-date-picker>
                </mu-col>
              </mu-row>
              <mu-row class="bottom">
                <mu-col desktop="50" tablet="50">
                  <div>
                    <span v-text="$t('message.nutrientCalories')"></span>
                    <span v-text="rounded(activeServingObject.nutrients.calories * model.servings)"></span>
                    <span>kcal</span>
                  </div>
                  <div>
                    <span v-text="$t('message.nutrientFat') + ': '"></span>
                    <span v-text="rounded(activeServingObject.nutrients.fat * model.servings)"></span>
                    <span>g</span>
                  </div>
                  <div>
                    <span v-text="$t('message.nutrientCarbohydrate') + ': '"></span>
                    <span v-text="rounded(activeServingObject.nutrients.carbohydrate * model.servings)"></span>
                    <span>g</span>
                  </div>
                </mu-col>
                <mu-col desktop="50" tablet="50">
                  <div>
                    <span v-text="$t('message.nutrientProtein') + ': '"></span>
                    <span v-text="rounded(activeServingObject.nutrients.protein * model.servings)"></span>
                    <span>g</span>
                  </div>
                  <div>
                    <span v-text="$t('message.nutrientSugar')"></span>
                    <span v-text="rounded(activeServingObject.nutrients.sugar * model.servings)"></span>
                    <span>g</span>
                  </div>
                </mu-col>
              </mu-row>
              <mu-raised-button
                label="Full nutrition"
                @click.native="toggleNutritionPane()"
                fullWidth
              ></mu-raised-button>
            </mu-content-block>
          </mu-col>
          <mu-col width="100" desktop="50" tablet="50" class="rightPane" v-if="isNutritionPaneVisible">
            <mu-card-header
              class="removePadding"
              :subTitle=" model.servings + ' x ' + activeServingObject.serving_description"
            ></mu-card-header>
            <mu-divider></mu-divider>
            <mu-list class="oddEven">
              <mu-list-item
                disableRipple
                v-for="(value, key) in activeServingObject.nutrients"
                :key="'nutrient-'+ key"
                :title="$t(localizeNutrient(key))"
                :afterText="'' + rounded(value * model.servings) + getUnit(key)"
              >
              </mu-list-item>
            </mu-list>
          </mu-col>
        </mu-row>
      </div>
      <mu-card-actions class="card-actions" align="right" v-show="!isLoading">
        <mu-flat-button
          :label="$t('message.cancelText')"
          @click="closeDialog('addFoodDialog')"
        ></mu-flat-button>
        <mu-raised-button
          :disabled="isSaving"
          :label="isSaving ? $t('message.updatingText') : $t('message.updateText')"
          @click.native="updateFood()"
          secondary
        ></mu-raised-button>
      </mu-card-actions>
    </mu-paper>
  </div>
</template>
<script>


  import FoodApi from '../../../api/Food'

  import config from '../../../config';
  import dateFormat from '../../../helpers/DatePickerManager'
  import NutrientLocalizerMixin from '../../../mixins/Localization/FoodNutrients/NutrientLocalizer'

  let numeral = require('numeral');

  const leftPaneWidth = {
    desktop: "100",
    tablet: "100"
  };

  const servingPickerWidth = {
    servingInput: {
      desktop: "20",
      tablet: "20"
    },
    servingSelector: {
      desktop: "80",
      tablet: "80"
    }
  };

  export default {
    mixins: [NutrientLocalizerMixin],
    props: {
      title: {
        type: String,
        default: "Edit"
      },
      foodObj: {
        type: Object
      },
      mealTypeId: {
        type: Number
      }
    },
    watch: {
      'timeModel.time': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
      'timeModel.date': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
      'model.serving_id': function () {
        let self = this, serving_id = self.model.serving_id;
        self.activeServingObject = self.food.servings.filter(function (item) {
          return item.serving_id === self.model.serving_id;
        })[0];
      }
    },
    data() {
      return {
        maxDate: moment().format('DD-MM-YYYY'),
        dateFormat: dateFormat,
        date: new Date(),
        isSaving: false,
        isLoading: true,
        isNutritionPaneVisible: false,
        scroller: document.getElementsByClassName('main-content')[0],
        activeServingObject: {},
        food: {},
        leftPaneWidth: leftPaneWidth,
        servingPickerWidth: servingPickerWidth,
        timeModel: {
          date: "",
          time: ""
        },
        model: {
          date: "",
          servings: 1,
          serving_id: 1
        }
      }
    },
    mounted() {
      let self = this;
      if (self.mealTypeId === undefined) {
        self.$router.push({
          name: "FoodDiary"
        })
      }
      else {
        let date = moment(self.foodObj.date_created);
        self.timeModel.time = date.format('hh:mm a');
        self.timeModel.date = date.format('DD-MM-YYYY');
        self.leftPaneWidth.desktop = "100";
        self.leftPaneWidth.tablet = "100";
        FoodApi.getById(self.foodObj.fs_food_id)
          .then(function (response) {
            self.food = response.data.food;
            self.model.serving_id = self.foodObj.fs_serving_id;
            self.model.servings = self.foodObj.servings;
            self.isLoading = false;
          });
      }
    },
    methods: {
      isDst(now) {
        if (moment(now).isDST()) {
          return true;
        }
        return false;
      },
      setServingSize(size) {
        let self = this;
        self.model.servings = size;
        self.$forceUpdate();
      },
      updateFood() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isSaving = true;
              let model = {
                date: self.model.date,
                food_id: self.foodObj.food_id,
                food_name: self.food.food_name,
                servings: self.model.servings,
                serving_id: self.model.serving_id,
                nutrients: self.activeServingObject.nutrients
              };
              FoodApi.updateFood(model)
                .then(function (response) {
                  self.$router.push({
                    name: "FoodDiary",
                    query: {
                      date: moment(self.model.date).format('YYYY-MM-DD')
                    }
                  })
                })
            }
          });
      },
      toggleNutritionPane() {
        let self = this;
        self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
        if (self.isNutritionPaneVisible !== true) {
          self.leftPaneWidth.tablet = "100";
          self.leftPaneWidth.desktop = "100";
          self.servingPickerWidth.servingInput.desktop = "20";
          self.servingPickerWidth.servingInput.tablet = "20";
          self.servingPickerWidth.servingSelector.desktop = "80";
          self.servingPickerWidth.servingSelector.tablet = "80";
        }
        else {
          self.leftPaneWidth.tablet = "50";
          self.leftPaneWidth.desktop = "50";
          self.servingPickerWidth.servingInput.desktop = "40";
          self.servingPickerWidth.servingInput.tablet = "40";
          self.servingPickerWidth.servingSelector.desktop = "60";
          self.servingPickerWidth.servingSelector.tablet = "60";
        }
      },
      rounded(num) {
        let number = numeral(num.toFixed(2));
        return number.format('0,0.0')
      },
      humanize(str) {
        var frags = str.split('_');
        for (var i = 0; i < frags.length; i++) {
          frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
        }
        return frags.join(' ');
      },
      getUnit(key) {
        switch (key) {
          case 'calories':
            return 'kcal';
            break;
          case 'protein':
            return 'g';
            break;
          case 'carbohydrate':
            return 'g';
            break;
          case 'sugar':
            return 'g';
            break;
          case 'fat':
            return 'g';
            break;
          case 'saturated_fat':
            return 'g';
            break;
          case 'monounsaturated_fat':
            return 'g';
            break;
          case 'polyunsaturated_fat':
            return 'g';
            break;
          case 'cholesterol':
            return 'g';
            break;
          case 'fibre':
            return 'g';
            break;
          case 'sodium':
            return 'mg';
            break;
          case 'potassium':
            return 'mg';
            break;
        }
      },
      userDecidesTo(option) {
        this.$emit('choseToSearchWith', option);
      },
      closeDialog(ref) {
        let self = this;
        self.$router.push({
          name: "FoodDiary",
          query: {
            date: moment(self.model.date).format('YYYY-MM-DD')
          }
        })
      }
    }
  }
</script>
<style>
  .danger {
    background: #e74c3c;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?63b9e1d6